// extracted by mini-css-extract-plugin
export default {"container":"KeyboardSlot_container__tHwwC"};